import { render, staticRenderFns } from "./template.vue?vue&type=template&id=1b779dad&scoped=true"
var script = {}
import style0 from "./template.vue?vue&type=style&index=0&id=1b779dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b779dad",
  null
  
)

export default component.exports